var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.338 15.338H12.67V11.16C12.67 10.165 12.653 8.883 11.283 8.883C9.893 8.883 9.682 9.969 9.682 11.09V15.338H7.014V6.748H9.573V7.922H9.61C9.966 7.247 10.837 6.535 12.136 6.535C14.839 6.535 15.339 8.313 15.339 10.627V15.338H15.338ZM4.005 5.575C3.80171 5.5752 3.60038 5.53535 3.41249 5.45774C3.2246 5.38013 3.05384 5.26627 2.90996 5.12266C2.76607 4.97906 2.65188 4.80852 2.57391 4.62078C2.49593 4.43304 2.4557 4.23179 2.4555 4.0285C2.4553 3.82521 2.49515 3.62388 2.57276 3.43599C2.65037 3.2481 2.76423 3.07734 2.90784 2.93346C3.05144 2.78957 3.22198 2.67538 3.40972 2.59741C3.59746 2.51943 3.79871 2.4792 4.002 2.479C4.41255 2.4786 4.80645 2.64131 5.09704 2.93134C5.38763 3.22136 5.5511 3.61494 5.5515 4.0255C5.5519 4.43606 5.38919 4.82995 5.09916 5.12054C4.80914 5.41113 4.41556 5.5746 4.005 5.575ZM2.668 15.338H5.34V6.748H2.667V15.338H2.668ZM16.668 0H1.328C0.595 0 0 0.581 0 1.298V16.701C0 17.418 0.595 18 1.328 18H16.668C17.402 18 18 17.418 18 16.701V1.298C18 0.581 17.402 0 16.668 0Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.5743baccee86c19e64cd33fff6f710e7.svg";
export { ForwardRef as ReactComponent };